export var isNumeric = function (e) {
    return /^\d*$/.test(e.key);
};
export var BACKSPACE_KEY_CODE = 'Backspace';
export var ENTER_KEY_CODE = 'Enter';
export var DELETE_KEY_CODE = "Delete";
